export default __webpack_public_path__ + "assets/tonga-flag.png";